import { rem } from 'polished'
import React, { ReactElement, ReactNode, useMemo } from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import Heading from 'components/Luxkit/Typography/Heading'
import { tileDesktopLayout } from './constants'
import LoyaltyPointsEarnWithBreakdownModal from 'loyalty/components/Earn/LoyaltyPointsEarnWithBreakdownModal'
import { LoyaltyPointsEarningConfiguration } from './CartReviewTile'

const Container = styled(Group)`
  grid-area: primary-content;

  ${tileDesktopLayout} {
    padding: ${rem(20)} 0;
  }
`

const LabelsContainer = styled(LabelGroup)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;

  &:not(.always-display) {
    ${tileDesktopLayout} {
      display: none;
    }
  }

`

const CancellationWrapper = styled.div`
  width: fit-content;
  margin-bottom: ${rem(12)};
`

interface Props {
  title: string
  dates?: string | false
  packageTitle?: string | Array<string>
  metaData?: ReactElement | false
  occupancy?: string | false
  cancellationPolicy?: ReactNode
  label?: ReactElement
  alwaysDisplayLabel?: boolean
  loyaltyPointsEarningConfiguration?: LoyaltyPointsEarningConfiguration,
  hideAvailabilityDetails?: boolean
  hideTitleAndDates?: boolean
  roomName?: string
}

function CartReviewTilePrimaryContent(props: Props) {
  const {
    title,
    dates,
    packageTitle,
    metaData,
    occupancy,
    cancellationPolicy,
    label,
    alwaysDisplayLabel,
    loyaltyPointsEarningConfiguration,
    hideAvailabilityDetails = false,
    hideTitleAndDates = false,
    roomName,
  } = props

  const packageTitles = useMemo<Array<string>>(() => {
    if (!packageTitle) return []
    if (Array.isArray(packageTitle)) {
      return packageTitle
    }
    return [packageTitle]
  }, [packageTitle])

  return (
    <Container direction="vertical" gap={12}>
      {!hideAvailabilityDetails && <LabelsContainer className={alwaysDisplayLabel ? 'always-display' : undefined}>
        {label}
      </LabelsContainer>}
      {!hideTitleAndDates && <Group direction="vertical" gap={4}>
        <Heading variant="heading6">{title}</Heading>
        <BodyText variant="medium" colour="neutral-two">{dates}</BodyText>
      </Group>}
      <Group direction="vertical" gap={2}>
        {roomName && <BodyText variant="medium" colour="neutral-two">{roomName}</BodyText>}
        {!roomName && packageTitles.map((pkgTitle) => <BodyText
          key={pkgTitle}
          variant="medium"
          colour="neutral-two"
          lineClamp={5}
        >
          {pkgTitle}
        </BodyText>)}
        {metaData}
        {!!occupancy && <BodyText variant="medium" colour="neutral-two">{occupancy}</BodyText>}
        {!hideAvailabilityDetails && <CancellationWrapper>
          {cancellationPolicy}
        </CancellationWrapper>}
        {!hideAvailabilityDetails && loyaltyPointsEarningConfiguration && <LoyaltyPointsEarnWithBreakdownModal calculationRequests={loyaltyPointsEarningConfiguration.calculationRequests} calculationType={loyaltyPointsEarningConfiguration.calculationType} hideStatusCredits={loyaltyPointsEarningConfiguration.hideStatusCredits}/>}
      </Group>
    </Container>
  )
}

export default CartReviewTilePrimaryContent
